const initialState = [
  'MR_COLLECTION_FIRST_SHIPMENT',
  'MR_COLLECTION_SECOND_SHIPMENT',
];
const initialStateForTest = [
  'MR_COLLECTION_FIRST_SHIPMENT',
  'MR_COLLECTION_SECOND_SHIPMENT',
];

export default initialState;
export { initialStateForTest };
